export const TAU = Math.PI * 2;


export function rad(deg)
{
    return deg * TAU / 360;
}



// WEBPACK FOOTER //
// ./src/util/math.js